import React, {useEffect} from 'react';
import {BubbleMapZoomable} from "./components/map/map-permits.js";
import {Categories} from "./components/categories/categories.js";
import {CategoryList} from "./components/categories/category_list.js";
import {Country} from "./components/country/country.js";
import {Search} from "./components/search.js";
import {ModelConsumer} from "./helpers/model/model-consumer.js";
import {ModelCountriesMain} from "./models/country.js";
import {InfoShareButtons} from "./components/info-share/buttons.js";
import {Header} from "./components/header/header.js";
import {useStateContext} from './helpers/state-context.js';
import {Analytics} from './helpers/analytics/index.js';
import {useModel} from './helpers/model/use_model.js';

function App() {
    const [state] = useStateContext(['country', 'page']);
    const countries =  useModel(ModelCountriesMain);

    useEffect(() => {
        // without the timeout the initial page view isn't tracked for some reason
        const timerId = setTimeout(() => {
            if(countries.status === ModelCountriesMain.Status.SUCCESS){
                let title = state.page || 'home';
                const country = countries.data.raw.find((countryItem) => (
                    countryItem.country_code === state.country
                ));
                if(country){
                    title = country.country_name;
                }
                Analytics.trackPageView({
                    title: 'Worldmap - ' + title
                });
            }

        }, 100);
        return () => {
            clearTimeout(timerId);
        }
    }, [state.country, state.page, countries]);

    return (
        <div>
            <Header/>
            <div style={{overflow: 'auto'}}>
                <div style={{height: 'calc(100vh - 55px)', position: 'relative', width: '100%'}}>
                    <Categories/>
                    <CategoryList/>
                    <Search/>
                    <Country/>
                    <InfoShareButtons/>
                    <div className={'map'} style={{height: '100%', position: 'relative', width: '100%'}} >
                        <ModelConsumer model={ModelCountriesMain}
                                selectionCriteria={(state)=>({categories: state.categories})}>
                            {(resultSet) => <BubbleMapZoomable resultSet={resultSet}/>}
                        </ModelConsumer>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default App;
